import { RouteRecordRaw } from 'vue-router'

export const rAuth: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'Login',
    component: () => import('@/views/auth/LoginPage.vue')
  },
  {
    path: 'forgot',
    name: 'Forgot',
    component: () => import('@/views/auth/ForgotPassword.vue')
  }
]
